import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import { PieTooltipProps } from "@nivo/pie";
import { IconChartDonut } from "@tabler/icons-react";
import { filter, map } from "lodash";
import { useCallback } from "react";
import Functions from "../../../callable/functions";
import Pizza, { PizzaData } from "../../util/charts/pizza";
import MoedaText from "../../util/ui/inputs/moedaText";
import Produto from "../../../models/analises/produto";
import Ticker from "../../util/ui/ticker";
import FelixCard from "../../util/ui/felixCard";
import TabelaDistribuicao from "../../util/tabelas/tabelaDistribuicao";
import ChartContainer from "../../util/charts/chartContainer";
import usePromise from "../../util/usePromise";
import { felixTokens, radius } from "../../../theme";

export default function CardProdutos() {
  const obterProdutosPromise = useCallback(
    () =>
      new Functions()
        .obterProdutos()
        .then((res) => map(res.data, Produto.fromJson)),
    []
  );
  const { data: produtos = [], loading } = usePromise(obterProdutosPromise);

  const formatTooltip = (point: PieTooltipProps<PizzaData>) => {
    return (
      // Tooltip de gráfico: surface + hairline (herdados do Card do tema),
      // elevação só pela sombra de overlay. Ver DESIGN.md → Gráficos.
      <Card
        elevation={0}
        sx={{ boxShadow: felixTokens.shadow.overlay, borderRadius: radius.sm }}
      >
        <Box display="flex" flexDirection="column" padding={1.5}>
          <Typography variant="labelMono" color="text.secondary">
            {point.datum.data.aux.codigoAtivo}
          </Typography>
          <Box paddingY={0.5} />
          <Typography
            variant="dataMono"
            color="text.primary"
            sx={{ fontWeight: 500 }}
          >
            {<MoedaText value={point.datum.data.value} />}
            <Typography
              variant="dataMono"
              display="inline"
              color="text.secondary"
              sx={{ fontSize: 12 }}
            >
              {` (${point.datum.data.aux.quantidade} UN.)`}
            </Typography>
          </Typography>
        </Box>
      </Card>
    );
  };

  const produtosCustodia = filter(produtos, (p) => p.saldoBruto > 0);

  const data = map(produtosCustodia, (p) => ({
    value: p.saldoBruto,
    label: p.codigoAtivo,
    id: p.codigoAtivo,
    formatedLabel: p.codigoAtivo,
    aux: p,
  }));

  return (
    <FelixCard>
      <CardHeader title="Produtos" avatar={<IconChartDonut size={16} />} />
      <CardContent>
        <Box display="flex" flexDirection="column">
          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            gap={2}
          >
            <ChartContainer
              height={300}
              emptyText="Ainda não há resultados mensais."
              isEmpty={data.length === 0}
              isLoading={loading}
            >
              <Pizza
                data={data}
                colorTheme="charts"
                formatTooltip={formatTooltip}
              />
            </ChartContainer>
            <TabelaDistribuicao
              data={data}
              quantidade={true}
              idComponent={(id) => <Ticker codigoAtivo={id} />}
            />
          </Box>
          <Box paddingY={2} />
          {!!produtos[0] ? (
            <Box alignSelf="flex-end">
              <Typography variant="labelMono" color="text.secondary">
                em {produtos[0].data.format("DD/MM/YY")}
              </Typography>
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </CardContent>
    </FelixCard>
  );
}
